import React from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import { useSelector } from "react-redux";
import { UserRound, Mail, Phone, CalendarPlus } from "lucide-react";

const TenantInfo = ({ leaseDetails }) => {
  const { loginSuccess } = useSelector((state) => state.auth);

  return (
    <div className="bg-white rounded-xl">
      <div className="px-4 pt-4">
        <ParagraphTag
          content="Tenant Info"
          classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
        />
      </div>
      <div className="flex mt-1 items-center  pb-4 pl-4">
        <div>
          <div className="pt-3 flex w-full">
            <div className="w-full flex items-end">
              <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                <UserRound color="#FF814E" strokeWidth={2} size={20} />
              </div>
              <div className="pl-2">
                <ParagraphTag
                  content="Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
          <div className="pt-3 w-full flex items-center">
            <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
              <Mail color="#FF814E" strokeWidth={2} size={20} />
            </div>
            <div className="pl-2">
              <ParagraphTag
                content="Email Address"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={loginSuccess?.user?.email}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
              />
            </div>
          </div>
          <div className="pt-3 flex">
            <div className="w-full flex items-center">
              <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                <Phone color="#FF814E" strokeWidth={2} size={20} />
              </div>
              <div className="pl-2">
                <ParagraphTag
                  content="Phone"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={loginSuccess?.user?.cellNo}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantInfo;
